import api from './api';

export interface Task {
  id: string;
  wedding_id: string;
  topic_id: string | null;
  parent_task_id: string | null;
  title: string;
  description: string | null;
  status: 'pending' | 'in_progress' | 'completed';
  priority: 'low' | 'medium' | 'high';
  due_date: string | null;
  assigned_planner_id: string | null;
  scheduling_constraints: string | null;
  notes: string | null;
  is_pinned: boolean;
  budget_expected: number | null;
  budget_actual: number | null;
  budget_paid: number | null;
  payment_on_wedding_day: boolean;
  created_at: string;
  updated_at: string;
  topic_all_tasks_completed?: { topic_id: string; topic_name: string } | null;
}

export interface TaskFormData {
  title: string;
  description?: string | null;
  status?: string;
  priority?: string;
  due_date?: string | null;
  assigned_planner_id?: string | null;
  topic_id?: string | null;
  scheduling_constraints?: string | null;
  notes?: string | null;
  is_pinned?: boolean;
  budget_expected?: number | null;
  budget_actual?: number | null;
  budget_paid?: number | null;
  payment_on_wedding_day?: boolean;
}

export const getTasks = (params?: Record<string, string>) =>
  api.get<Task[]>('/tasks', { params });
export const getTask = (id: string) => api.get<Task>(`/tasks/${id}`);
export const createTask = (data: TaskFormData) => api.post<Task>('/tasks', data);
export const updateTask = (id: string, data: Partial<TaskFormData>) =>
  api.put<Task>(`/tasks/${id}`, data);
export const deleteTask = (id: string) => api.delete(`/tasks/${id}`);
